import { withTooltip } from '../Tooltip'
import { Badge } from './Badge'

export const BadgeWithTooltip = withTooltip(Badge)
